import { createAction } from 'redux-actions';

export const resetMfaAuth = createAction('RESET_MFA_AUTH');
